import { render, staticRenderFns } from "./ConfigItemAddEdit.vue?vue&type=template&id=caf94768&"
import script from "./ConfigItemAddEdit.vue?vue&type=script&lang=js&"
export * from "./ConfigItemAddEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports